import { render } from "./InstanceDetailView.vue?vue&type=template&id=619179dc&scoped=true&ts=true"
import script from "./InstanceDetailView.vue?vue&type=script&lang=ts"
export * from "./InstanceDetailView.vue?vue&type=script&lang=ts"

import "./InstanceDetailView.vue?vue&type=style&index=0&id=619179dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619179dc"]])

export default __exports__